const state = {
  benefits: [],
  benefits_id: [],
};

export default state;
